import { Methods } from '../../shared/constants/method';
import { JobRequest } from '../models/job';

export const generateReportTemplate: Pick<JobRequest, 'service' | 'path' | 'method'> = {
  service: 'Report',
  path: '/data/generate',
  method: Methods.POST,
};
